// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const CatalogPerson = zod.object({
  "display_name": zod.string(),
  "id": zod.uuid()
});

export type CatalogPerson = zod.input<typeof CatalogPerson>;
export type CatalogPersonOutput = zod.output<typeof CatalogPerson>;
